@if (this.newVersionAvailable()) {
  @let visible = this.popoverVisible();
  <div [ngClass]="{ container: true, visible }">
    <mat-card>
      <div class="content">
        <h3>New Manager Version Available</h3>
        <p>
          A new version of the manager is now available. Click the button below
          of refresh your browser to move to the new version
        </p>
        <p>
          <strong>
            Make sure you finish and save anything you are currently working on
          </strong>
        </p>
        <p class="version current">
          <strong>Current:</strong>
          <span>{{ currentVersion().commit }}</span>
        </p>
        <p class="version latest">
          <strong>New:</strong>
          <span>{{ store.version()?.commit }}</span>
        </p>
        <div class="buttons">
          <button matButton="filled" class="reload" (click)="refresh()">
            Reload
          </button>
          <button
            matButton="filled"
            class="dismiss"
            (click)="popoverVisible.set(false)">
            Dismiss
          </button>
        </div>
      </div>
      <button
        class="open"
        matIconButton
        (click)="popoverVisible.set(true)"
        aria-label="New Version Available">
        <mat-icon>electric_bolt</mat-icon>
      </button>
    </mat-card>
  </div>
}
